var map = {
	"./cert-E-commerce-hkgcsmeaa.jpg": 160,
	"./cert-customer-hkgcsmeaa.jpg": 161,
	"./cert-finance-hkgcsmeaa.jpg": 163,
	"./cert-fsi-hkgcsmeaa.jpg": 165,
	"./cert-general-staff-hkgcsmeaa.jpg": 167,
	"./cert-general2024-hkgcsmeaa.jpg": 124,
	"./cert-hr-hkgcsmeaa.jpg": 168,
	"./cert-it-hkgcsmeaa.jpg": 169,
	"./cert-market-hkgcsmeaa.jpg": 170,
	"./cert-ngo-hkgcsmeaa.jpg": 171,
	"./cert-senior-manager-hkgcsmeaa.jpg": 173,
	"./cert-startup-hkgcsmeaa.jpg": 174,
	"./cert-student-hkgcsmeaa.jpg": 176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1631;